import React, { useState, useMemo } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const validateInputFields = (props, setErrorField) => {
  let specialCharListName = /^[A-Za-z]+$/;
  let specialCharListEmailId = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  let specialCharListMobNo = /^[0-9]+$/;
  let specialCharListEmpId = /^[A-Za-z0-9]+$/;
  const error = {};
  if (!props.firstName || !specialCharListName.test(props.firstName)) {
    error["firstName"] = {
      msg: "First name cannot have spaces or special characters or numbers",
    };
  }
  if (!props.lastName || !specialCharListName.test(props.lastName)) {
    error["lastName"] = {
      msg: "Last name cannot have spaces or special characters or numbers",
    };
  }
  if (!props.emailAdd || !specialCharListEmailId.test(props.emailAdd)) {
    error["emailAdd"] = {
      msg: "Please enter a valid Email ID",
    };
  }
  if (
    !props.phone ||
    !specialCharListMobNo.test(props.phone) ||
    isNaN(props.phone) ||
    props.phone.length > 12
  ) {
    error["phone"] = {
      msg: "Please enter a valid Mobile No.",
    };
  }
  if (!props.empId || !specialCharListEmpId.test(props.empId)) {
    error["empId"] = {
      msg: "Please enter a valid Employee ID",
    };
  }
  if (!props.role || props.role == "") {
    error["role"] = {
      msg: "Please select a valid Role",
    };
  }
  const errorCount = Object.keys(error).length;
  setErrorField(errorCount > 0 ? error : null);
  return errorCount > 0 ? true : false;
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    zIndex: "0",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
    "& .MuiStepIcon-active": { color: "rgb(98, 42, 216)" },
    "& .MuiStepIcon-completed": { color: "rgb(98, 42, 216)" },
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const UserDetails = (props) => {
  const classes = useStyles();

  const [errorField, setErrorField] = useState(null);

  const setChange = (value, id) => {
    props.setFormData((prev) => {
      return {
        ...prev,
        [id]: value,
      };
    });
  };
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Personal Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            error={
              errorField && errorField.hasOwnProperty("firstName")
                ? true
                : false
            }
            helperText={
              errorField && errorField.hasOwnProperty("firstName")
                ? errorField["firstName"].msg
                : " "
            }
            onChange={(e) => {
              e.preventDefault();
              setChange(e.target.value, "firstName");
            }}
            inputProps={{ spellCheck: 'false' }}
            value={props.formData["firstName"]}
            required
            id="firstName"
            name="firstName"
            label="First name"
            fullWidth
            autoComplete="first-name"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            error={
              errorField && errorField.hasOwnProperty("lastName") ? true : false
            }
            helperText={
              errorField && errorField.hasOwnProperty("lastName")
                ? errorField["lastName"].msg
                : " "
            }
            onChange={(e) => {
              e.preventDefault();
              setChange(e.target.value, "lastName");
            }}
            inputProps={{ spellCheck: 'false' }}
            value={props.formData["lastName"]}
            required
            id="lastName"
            name="lastName"
            label="Last name"
            fullWidth
            autoComplete="last-name"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            error={
              errorField && errorField.hasOwnProperty("emailAdd") ? true : false
            }
            helperText={
              errorField && errorField.hasOwnProperty("emailAdd")
                ? errorField["emailAdd"].msg
                : " "
            }
            value={props.formData["emailAdd"]}
            onChange={(e) => {
              e.preventDefault();
              setChange(e.target.value, "emailAdd");
            }}
            inputProps={{ spellCheck: 'false' }}
            required
            id="emailAdd"
            name="email"
            label="Email address"
            fullWidth
            autoComplete="email-address"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            error={
              errorField && errorField.hasOwnProperty("phone") ? true : false
            }
            helperText={
              errorField && errorField.hasOwnProperty("phone")
                ? errorField["phone"].msg
                : " "
            }
            value={props.formData["phone"]}
            onChange={(e) => {
              e.preventDefault();
              setChange(e.target.value, "phone");
            }}
            inputProps={{ spellCheck: 'false' }}
            required
            id="phone"
            name="phone"
            label="Phone number"
            type="number"
            fullWidth
            autoComplete="phone-number"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            error={
              errorField && errorField.hasOwnProperty("empId") ? true : false
            }
            helperText={
              errorField && errorField.hasOwnProperty("empId")
                ? errorField["empId"].msg
                : " "
            }
            value={props.formData["empId"]}
            onChange={(e) => {
              e.preventDefault();
              setChange(e.target.value, "empId");
            }}
            inputProps={{ spellCheck: 'false' }}
            id="empId"
            name="employeeID"
            label="Employee ID"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            error={
              errorField && errorField.hasOwnProperty("role") ? true : false
            }
            helperText={
              errorField && errorField.hasOwnProperty("role")
                ? errorField.role.msg
                : "Assign Role"
            }
            id="role"
            select
            label="Select"
            fullWidth
            value={props.formData["role"]}
            onChange={(e) => {
              e.preventDefault();
              const { value } = e.target;
              props.setFormData((prev) => ({
                ...prev,
                role: value,
              }));
            }}
            variant="outlined"
            SelectProps={{
              MenuProps: {
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              },
            }}
          >
            {props.roles.map((option) => (
              <MenuItem key={option[0]} value={option[0]}>
                {option[1]}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <div className={classes.buttons}>
        <Button
          variant="contained"
          style={{
            backgroundColor: "rgb(98, 42, 216)",
            color: "white",
          }}
          onClick={() => props.onSubmit(validateInputFields, setErrorField)}
          className={classes.button}
        >
          Add User
        </Button>
      </div>
    </React.Fragment>
  );
};

export default UserDetails;
